<template>
  <div class="footer-block">
    <div class="container">
      <div class="title">
        <img src="./images/Beginning-Title-SVG.svg">
      </div>
      <p class="text">
        TRUE World is <span>alive, evolving, and&nbsp;waiting for you</span>.<br>
        Whether you’re a&nbsp;strategist, a&nbsp;risk-taker, or a&nbsp;dreamer, there is a place<br> for you in this universe.&nbsp;<span>Are you ready?</span></p>
      <div class="links">
        <router-link :to="{name: 'world'}">
          Start your adventure
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer-block',
}
</script>

<style lang="less" scoped>
  .footer-block {
    position: relative;
    top: 0;
    padding-top: 357px;
    min-height: 870px;
    background-image: url("./images/Beginning-BG.jpg");
    background-position: top;
    background-repeat: no-repeat;
    background-size: 1920px;
    > .container {
      > .title {
        font-size: 60px;
        font-weight: 700;
        line-height: 90px;
        letter-spacing: 0.04em;
        text-align: center;
        margin-bottom: 30px;
        text-transform: uppercase;
        color: #fff;
        > span {
          display: block;
          font-size: 26px;
          font-weight: 300;
          line-height: 39px;
          letter-spacing: 0.3em;
          text-align: center;
          color: rgba(255,255,255,0.8);
        }
      }
      > .text {
        color: #FFFFFF99;
        font-family: Poppins;
        font-weight: 500;
        font-size: 24px;
        line-height: 38px;
        text-align: center;
        margin-bottom: 30px;
        > span {
          color: #FFF;
        }
      }
      > .links {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-bottom: 98px;
        gap: 6px;
        > a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 310px;
          height: 60px;
          border-radius: 14px;
          color: #fff;
          font-family: Poppins;
          font-weight: 700;
          font-size: 16px;
          line-height: 100%;

          background: linear-gradient(90deg, #9D5BFF 0%, #563AE7 100%);
          &:hover {
            background: linear-gradient(90deg, #9D5BFF 10%, #563AE7 110%);
          }
        }
      }
    }
  }

  @media screen and (max-width: 1439px) {
    .footer-block {
      position: relative;
      top: 0;
      padding-top: 247px;
      min-height: 664px;
      background-image: url("./images/Beginning-BG.jpg");
      background-position: top;
      background-repeat: no-repeat;
      background-size: 1466px;
      > .container {
        > .title {
          margin-bottom: 30px;
          > img {
            width: 770px;
          }
        }
        > .text {
          font-size: 20px;
          line-height: 30px;
          margin-bottom: 30px;
          > span {
            color: #FFF;
          }
        }
        > .links {
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-bottom: 98px;
          gap: 6px;
          > a {
            width: 220px;
            height: 50px;
            border-radius: 12px;
            font-weight: 600;
            font-size: 14px;
            line-height: 100%;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1023px) {
    .footer-block {
      position: relative;
      top: 0;
      padding-top: 247px;
      min-height: 542px;
      background-image: url("./images/Beginning-BG.jpg");
      background-position: top;
      background-repeat: no-repeat;
      background-size: 1196px;
      > .container {
        > .title {
          margin-bottom: 24px;
          > img {
            width: 578px;
          }
        }
        > .text {
          font-size: 16px;
          line-height: 26px;
          margin-bottom: 24px;
        }
        > .links {
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-bottom: 98px;
          gap: 6px;
          > a {
            width: 220px;
            height: 50px;
            border-radius: 12px;
            font-weight: 600;
            font-size: 14px;
            line-height: 100%;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .footer-block {
      position: relative;
      top: 0;
      padding-top: 107px;
      min-height: 322px;
      background-size: 508px;
      > .container {
        > .title {
          margin-bottom: 10px;
          > img {
            width: 276px;
          }
        }
        > .text {
          font-size: 13px;
          line-height: 22px;
          margin-bottom: 20px;
          padding: 0 14px;
          > br {
            display: none;
          }
        }
        > .links {
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-bottom: 98px;
          gap: 6px;
          > a {
            margin: 0 15px;
            width: 100%;
            height: 40px;
            border-radius: 12px;
            font-weight: 600;
            font-size: 13px;
            line-height: 100%;
          }
        }
      }
    }
  }
</style>
